<template>
  <router-view v-if="isUserLoggedIn" v-slot="{ Component }">
    <ChatBot v-if="isChatbotEnabled" :chatBotUrl="chatBotUrl" />
    <layout
      @logout-handler="logoutClickHandler"
      :user="userInfo"
      :hiddenLinkIds="hiddenLinkIds"
      :overridedLinks="overridedLinks"
      :isShowSubAccountMenuItem="checkGIBSellerInfoData?.subAccountManagement"
      @clickedMenuItem="clickedMenuItemControlFn($event)"
      :isShowInfluencerAd="getInfluencerAdsVisibility"
      :isShowSupplies="getIsSupplyAuthorized"
    >
      <component :is="Component" />
      <Modal
        ref="menuClickControlModalRef"
        @onNegativeActionClick="menuClickControlModalClose()"
        @onPositiveActionClick="menuClickControlModalNext()"
        :negativeActionText="pageCheckModalData?.negativeBtnText"
        :positiveActionText="pageCheckModalData?.positiveBtnText"
        :withCloser="!pageCheckModalData?.positiveBtnText"
        class="control-modal"
      >
        <template v-slot:body>
          <h3 class="control-modal-title">
            {{ pageCheckModalData?.title }}
          </h3>
          <p class="control-modal-text">
            {{ pageCheckModalData?.message }}
          </p>
        </template>
      </Modal>
      <Modal
        ref="checkGIBSellerInfoDataRef"
        :negativeActionText="isCheckGIBSellerInfoBehaviour ? 'Kapat' : ''"
        positiveActionText="Onayla"
        :withCloser="isCheckGIBSellerInfoBehaviour"
        :clickToClose="isCheckGIBSellerInfoBehaviour"
        @onNegativeActionClick="checkGIBSellerInfoModalClose()"
        @onPositiveActionClick="approveGIBSellerInfoBtn()"
        class="check-gib-modal"
      >
        <template v-slot:body>
          <p
            class="control-modal-text"
            v-html="checkGIBSellerInfoData?.content"
          />
        </template>
      </Modal>
      <NeedPasswordChangeModal ref="needChangePasswordModalRef" />
      <Toaster
        ref="toasterRef"
        :type="toasterData?.type"
        :title="toasterData?.title"
        :subtitle="toasterData?.description"
      />
    </layout>
  </router-view>
</template>

<script>
import { Layout, Modal, Toaster, Input, ChatBot } from "@n11/so-ui-components";
import { mapActions, mapGetters, mapMutations } from "vuex";
import loginRedirector from "@/utils/enum/loginRedirector";
import localStorageItems from "@/utils/enum/localStorageItems";
import MainFooter from "@/components/Footer/MainFooter";
import { GIB_CONTROL } from "@/utils/enum/pageCheckControl";
import {
  NEW_PRODUCT_LIST_DESIGN_ENABLE,
  NEW_PRODUCT_CREATE_DESIGN_ENABLE,
  NEW_BULK_PRODUCT_MANAGEMENT_DESIGN_ENABLE,
  CHATBOT_ENABLED,
  CHATBOT_URL,
} from "@/utils/enum/configs";
import NeedPasswordChangeModal from "@/views/SellerSubAccounts/partial/NeedPasswordChangeModal.vue";

export default {
  components: {
    Layout,
    MainFooter,
    Modal,
    Toaster,
    Input,
    NeedPasswordChangeModal,
    ChatBot,
  },
  data() {
    return {
      isUserLoggedIn: false,
      hiddenLinkIds: [],
      overridedLinks: [],
      pageCheckModalData: {},
      CHATBOT_URL,
    };
  },
  created() {
    this.redirectIfLoggedIn();
  },
  computed: {
    ...mapGetters({
      userInfo: "auth/getUserInfos",
      configList: "common/getConfigList",
      menuClickControlModalData: "navigation/getMenuClickControlModalData",
      toasterData: "common/getToasterData",
      checkGIBSellerInfoData: "common/getCheckGIBSellerInfoData",
      needPasswordChange: "common/getNeedPasswordChange",
      getInfluencerAdsVisibility: "common/getInfluencerAdsVisibility",
      config: "common/getConfigList",
      getIsSupplyAuthorized: "common/getIsSupplyAuthorized",
    }),
    isCheckGIBSellerInfoBehaviour() {
      return (
        this.checkGIBSellerInfoData?.behaviour !== GIB_CONTROL.FORCE_APPROVE
      );
    },
    isChatbotEnabled() {
      const v = this.config[CHATBOT_ENABLED];
      return (v === true || v === 'true') && !!this.userInfo?.sellerId;
    },
    chatBotUrl(){
      if (!this.userInfo?.sellerId) return '';
      const formArray = JSON.stringify([[String(this.userInfo?.sellerId), '19']]);
      return `${this.config[CHATBOT_URL]}?lang=tr&formArray=${formArray}`;
    },
  },
  methods: {
    ...mapActions({
      persistUserDataFn: "auth/persistUserData",
      logoutFn: "auth/logout",
      clickedMenuItemControlFn: "navigation/onNavigationChange",
      approveGIBSellerInfoFn: "products/approveGIBSellerInfo",
    }),
    ...mapMutations({
      SET_MENU_CLICKED_CONTROL_MODAL_DATA:
        "navigation/SET_MENU_CLICKED_CONTROL_MODAL_DATA",
      SET_TOASTER_DATA: "common/SET_TOASTER_DATA",
    }),
    async redirectIfLoggedIn() {
      const { isLoggedIn } = await this.persistUserDataFn();
      this.isUserLoggedIn = isLoggedIn;
      if (!isLoggedIn) {
        loginRedirector();
      }
    },
    logoutClickHandler() {
      localStorage.removeItem(localStorageItems.SELLER_ID);
      this.logoutFn();
    },
    checkAddCatalogIsEnable() {
      this.configList[NEW_PRODUCT_CREATE_DESIGN_ENABLE] === "true"
        ? this.overridedLinks.push({
            id: "productManagement",
            isNew: false,
          })
        : this.hiddenLinkIds.push("addCatalogProduct");
    },
    checkNewListingIsEnable() {
      this.configList[NEW_PRODUCT_LIST_DESIGN_ENABLE] === "true"
        ? this.overridedLinks.push({
            id: "productList",
            isNew: false,
          })
        : this.overridedLinks.push({
            id: "productList",
            href: "/selleroffice/product/products",
          });
    },
    checkNewBulkProductManagementIsEnable() {
      this.configList[NEW_BULK_PRODUCT_MANAGEMENT_DESIGN_ENABLE] === "true"
        ? this.overridedLinks.push({
            id: "bulkProductUpload",
            isNew: false,
          })
        : this.overridedLinks.push({
            id: "bulkProductUpload",
            href: "/selleroffice/integration/main",
          });
    },
    menuClickControlModalClose() {
      this.$refs.menuClickControlModalRef?.hiddenModal();
    },
    menuClickControlModalNext() {
      window.location.href = this.pageCheckModalData?.positiveBtnUrl;
    },
    checkGIBSellerInfoModalClose() {
      this.$refs.checkGIBSellerInfoDataRef?.hiddenModal();
    },
    async approveGIBSellerInfoBtn() {
      const result = await this.approveGIBSellerInfoFn();
      if (result?.success) {
        window.location.reload();
      }
    },
  },
  watch: {
    configList() {
      this.checkNewListingIsEnable();
      this.checkAddCatalogIsEnable();
      this.checkNewBulkProductManagementIsEnable();
    },
    menuClickControlModalData: {
      handler(val) {
        if (val.message) {
          this.pageCheckModalData = this.menuClickControlModalData;
          this.$refs.menuClickControlModalRef.openModal();
          this.SET_MENU_CLICKED_CONTROL_MODAL_DATA({});
        }
      },
      deep: true,
    },
    toasterData: {
      handler() {
        if (this.toasterData?.type) {
          this.$refs.toasterRef.show();
          setTimeout(() => {
            this.SET_TOASTER_DATA({
              type: "",
              title: "",
              description: "",
            });
          }, 500);
        }
      },
      deep: true,
    },
    checkGIBSellerInfoData: {
      handler() {
        if (
          this.checkGIBSellerInfoData?.behaviour === GIB_CONTROL.APPROVE ||
          this.checkGIBSellerInfoData?.behaviour === GIB_CONTROL.FORCE_APPROVE
        ) {
          if (this.$refs.checkGIBSellerInfoDataRef) {
            this.$refs.checkGIBSellerInfoDataRef.openModal();
          }
        }
      },
      deep: true,
    },
    needPasswordChange: {
      handler() {
        if (this.needPasswordChange) {
          if (this.$refs.needChangePasswordModalRef) {
            this.$refs.needChangePasswordModalRef.openModal();
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/global.scss";
@import "@/assets/styles/variables.scss";

body {
  min-height: 100vh;
  background-color: $colorBe20;
}

.control-modal {
  &-title {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
  }

  &-text {
    line-height: 1.4;
  }
}

@media screen and (max-width: 1200px) {
  .layout {
    background-color: $colorN10 !important;
    height: 100vh !important;
    overflow-x: hidden;
  }
  .layout_sidebar {
    display: none !important;
  }
  .navbar {
    margin-top: 60px;

    &_menu {
      overflow-x: scroll;
      overflow-y: hidden;
    }
    .navbarDropdown_link {
      position: inherit !important;
    }
  }

  .topMenu {
    display: none !important;
  }
  .layout_content {
    margin-left: 0 !important;
    width: 100% !important;
  }
}
@media screen and (max-width: 768px) {
  .layout {
    width: 100% !important;

    .navbar_wrapper {
      height: 70px;
      .container {
        display: block;
        .navbar {
          width: 100%;
          background-color: #f5f5f5;
          border-bottom: 1px solid #e0e0e0;
          padding-left: 15px;
          position: sticky;
          z-index: 1 !important;

          &_menu {
            height: 80px;
          }
        }
      }
    }
  }
}
</style>
